import { Dispatch, FC, memo, useCallback } from 'react';

// MUI
import Box from '@mui/material/Box';

// screen
import { FontDetails, TemplateSettings } from 'modules/map/components/daily-dish/types';
import { FIELD_WIDTHS } from 'modules/map/components/daily-dish/constants';
import { FONT_SIZE_LIMITS } from 'modules/map/components/daily-dish/config';

import StyledLabel from 'modules/map/components/daily-dish/components/utils/StyledLabel';
import {
  NumberFieldWithLimits,
  SelectField,
  ColorPickerField,
  FormFieldRow,
} from 'modules/map/components/daily-dish/components/form';
import { SettingsAction } from 'modules/map/components/daily-dish/reducer';

interface FontStyleSelectorProps {
  label: string;
  section: keyof TemplateSettings['font'];
  settings: TemplateSettings;
  dispatch: Dispatch<SettingsAction>;
}

const FontStyleSelector: FC<FontStyleSelectorProps> = memo((props) => {
  const { label, section, settings, dispatch } = props;

  const fontDetails = settings.font[section];
  const limits = FONT_SIZE_LIMITS[section];

  const fontFamilies = [
    { id: 1, name: 'Be Vietnam Pro' },
    { id: 2, name: 'Montserrat' },
    { id: 3, name: 'Poppins' },
    { id: 4, name: 'Time new roman' },
    { id: 5, name: 'Arial' },

    { id: 6, name: 'Bungee' },
    { id: 7, name: 'Dancing Script' },
    { id: 8, name: 'Pacifico' },
    { id: 9, name: 'Bangers' },
    { id: 10, name: 'Goldman' },

    { id: 11, name: 'Pangolin' },
    { id: 12, name: 'Potta One' },
    { id: 13, name: 'Bungee Inline' },
    { id: 14, name: 'Agbalumo' },
    { id: 15, name: 'Cherry Bomb' },

    { id: 16, name: 'UTM Seagull' },
    { id: 17, name: 'UTM Bebas' },
    { id: 18, name: 'UTM Cooper Black' },
    { id: 19, name: 'UTM Cafeta' },
    { id: 20, name: 'UTM Nokia Standard Bold' },
  ];

  const handleFontChange = (details: Partial<FontDetails>) => {
    dispatch({ type: 'UPDATE_FONT', section, details });
  };

  const handleChangeColor = useCallback(
    (details: Partial<FontDetails>) => {
      dispatch({ type: 'UPDATE_FONT', section, details });
    },
    [dispatch, section]
  );

  const fontFamilyOptions = fontFamilies.map((font) => ({
    value: font.id,
    label: font.name,
  }));

  return (
    <Box sx={{ mb: 4 }}>
      <StyledLabel label={label} sx={{ fontWeight: 600 }} />
      <Box
        sx={{
          display: 'flex',
          columnGap: 1,
          alignItems: 'flex-start',
          mb: 1,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <SelectField
            label="Font chữ"
            value={fontDetails.fontFamilyId}
            options={fontFamilyOptions}
            onChange={(value) => {
              const fontFamily = parseInt(value.toString());
              if (!Number.isNaN(fontFamily)) {
                handleFontChange({ fontFamilyId: fontFamily });
              }
            }}
            width={FIELD_WIDTHS.FULL}
          />
        </Box>
        <FormFieldRow sx={{ flex: 1 }}>
          <NumberFieldWithLimits
            label="Cỡ"
            value={fontDetails.fontSize}
            min={limits.min}
            max={limits.max}
            onChange={(fontSize) => handleFontChange({ fontSize })}
          />

          <ColorPickerField
            label="Màu"
            color={fontDetails.fontColor}
            onColorChange={(fontColor) => handleChangeColor({ fontColor })}
          />
        </FormFieldRow>
      </Box>
    </Box>
  );
});

export default FontStyleSelector;
